import { StoreServiceLibrary } from '../services/store/store.service';

export class SecurityModel {
    ip: string;
    host: string;
    cookie: string;
    userAgent: string;
    deviceFingerPrint: string;
}

export class SecurityObject {
    static getSecurityObject(): SecurityModel {
        const security = new SecurityModel();
        security.ip = '127.0.0.1';
        security.host = 'localhost';
        security.cookie = 'cookie';
        security.userAgent = StoreServiceLibrary.isWebLogin ? 'bitacora' : 'Application';
        security.deviceFingerPrint = StoreServiceLibrary.isWebLogin ? 'browser' : StoreServiceLibrary.securityDevice;
        return security;
    }
}



